export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);

  newState.sideNavigationPages = payload

  return newState;
};
